export const DEFAULT_FUND_ID = "605b2e5cc34cf5001154c90d";

export const IRIS_FUND_ID = "58e64b9523d2772e1859b705";

export const ASTER_SHORT_FUND_ID = "62690a20071ef07765246144";

export const ASTER_HY_FUND_ID = "62690582071ef0776524606c";

export const GLOBAL_FIXED_INCOME_FUND_ID = "649d36255de897ec4079bbae";

export const PERENNE_FUND_ID = "649d4a855de897ec4079d879";

export const DAHLIA_FUND_ID = "5b0d638cafcedd32f03a8ac7";

export const SWAP_CURVE_DEFINITION_ID = "5d9b2532f8653100121668d5";

export const SEK_OIS_CURVE_DEFINITION_ID = "5d9b2d22f8653100121668df";

export const BOND_ISINS = ["SE0014694659","SE0015503446","SE0018537086", "SE0020354082", "SE0021770708", "SE0024219877", "SE0028476044"];

export interface FoNavCdsIndex {
    /** Series independent key, used for weights and labels. */
    key: string;
    /** A known series and the roll date it went on the run, used to count the series forward. */
    anchorSeries: number;
    anchorRollDate: string;
    /** Instrument names with `{series}` for the series number. Later templates win when several exist for a series. */
    nameTemplates: string[];
}

export const FONAV_CDS_INDICES: FoNavCdsIndex[] = [
    {
        key: "ITRX EUR 5Y",
        anchorSeries: 45,
        anchorRollDate: "2026-03-20",
        nameTemplates: ["ITRX EUR CDSI S{series} 5Y", "ITRAXX-Europe-S{series}-5Y"]
    },
    {
        key: "ITRX XOVER 5Y",
        anchorSeries: 45,
        anchorRollDate: "2026-03-20",
        nameTemplates: ["ITRX XOVER CDSI S{series} 5Y", "ITRAXX-Xover-S{series}-5Y"]
    },
    {
        key: "CDX IG 5Y",
        anchorSeries: 46,
        anchorRollDate: "2026-03-20",
        nameTemplates: ["CDX IG CDSI S{series} 5Y", "CDX-NAIG-S{series}-5Y"]
    },
    {
        key: "CDX HY 5Y",
        anchorSeries: 46,
        anchorRollDate: "2026-03-20",
        nameTemplates: ["CDX HY CDSI S{series} 5Y PRC", "CDX-NAHY-S{series}-5Y"]
    }
];

export const FX_NAMES = ["EURSEK", "USDSEK"];

export const FONAV_RATE_SOURCES = ["internal", "seb"] as const;

export type FoNavRateSource = (typeof FONAV_RATE_SOURCES)[number];

export const FONAV_RATE_SOURCE_OPTIONS: { value: FoNavRateSource; label: string }[] = [
    { value: "internal", label: "Internal/Bloomberg" },
    { value: "seb", label: "External independent source" }
];

export const FONAV_RISK_TYPES = ["Bond", "Swaps", "Swaption", "CDS", "Other"] as const;

export type FoNavRiskType = (typeof FONAV_RISK_TYPES)[number];

export const FONAV_SWAPS_TENOR_WEIGHTS: Record<number, number> = {
    8: 0.25,
    9: 0.25,
    10: 0.25,
    12: 0.25
};

export const FONAV_CARRY_GROUPS = ["Bonds", "Swaps", "CDS"] as const;

export type FoNavCarryGroup = (typeof FONAV_CARRY_GROUPS)[number];

/**
 * Business days between trade and settlement, used to derive the settlement dates the carry accrues between.
 */
export const FONAV_CARRY_SETTLE_DAYS: Record<FoNavCarryGroup, number> = {
    Bonds: 2,
    Swaps: 0,
    CDS: 1
};

export const FONAV_CARRY_DAY_COUNT_BASIS = 365;

/**
 * Floating rate index referenced by the swap legs. Swap carry is the fixed rate over this rate,
 * so it is netted off the weighted average swap rate.
 */
export const SWAP_FLOATING_RATE_INSTRUMENT_ID = "558bc96133d8650bd478e335";
